import { createContext } from "react";

export const BookingContext = createContext({
  booked: {},
  setBooked: () => {},
  movieBook: {},
  setMovieBook: () => {},
  isBooking: false,
  setIsBooking: () => {}
})